export const qtyButtons = () => {

  $("span.stepperQtyPlus, .stepperQtyMinus").off("click tap")
  $("span.stepperQtyPlus, .stepperQtyMinus").on("click tap", function () {

 

    // For handling Requested & Fulfilled toggles
    if ($(this).hasClass('update')) {
      const span = $(this);
      const id = $(span).attr('key');
      const input = document.getElementById(id);
      let val = $(input).val();
      if (span.hasClass("stepperQtyPlus")) {
        // cant go above 'requested quantity' 
        // disable plus for purchased
        val++;
        $(input).val(val)
      } else if (span.hasClass("stepperQtyMinus")) {
        // cant go below purchased, 
        // cant go below original requested
        val--;
        $(input).val(val)
      }

    } else {
      // for handling Add to bag toggles

      var $span = $(this);
      var input = $span.parent().find("input");
      var currentValue = $span.parent().find("input").val();

      if ($span.hasClass("stepperQtyPlus")) {
        if (!currentValue) {
          currentValue = '0';
        }
        var val = parseFloat(currentValue) + 1;
        newValue = 0;
        if (val <= 99) {
          newValue = parseFloat(currentValue) + 1;
        } else {
          newValue = parseFloat(currentValue);
        }
      } else if ($span.hasClass("stepperQtyMinus")) {
        if (!currentValue) {
          currentValue = '2';
        }
        var newValue = 0;
        if (currentValue > 1) {
          newValue = parseFloat(currentValue) - 1;
        } else {
          newValue = currentValue;
        }
      }
      $(input).val(newValue);
    }
  });

  $("input#quantityInput").on("input propertychange paste", function (e) {
    var valInput = $(this).val()
    var regInput = /^0/gi;
    if (valInput.match(regInput)) {
      $(this).val(valInput.replace(regInput, "1"));
    }
  });

  $('input#quantityInput').on('click tap blur', function(e) {
    var value = $(this).val();
    if (value <= 0) {
      $(this).val('1');
    }
  });


  //
  // -------- specific to registry ----------
  //  
  const registryItems = document.getElementsByClassName('count count-action')

  const checkInputChanges = (e) => {
    const targetInput = e.target;
    const targetValue = e.target.value;
    const targetInputId = $(targetInput).attr('name');
    const targetMinus = $(targetInput).siblings('.stepperQtyMinus')[0];
    const targetPlus = $(targetInput).siblings('.stepperQtyPlus')[0];
    const origininalTargetAmount = $(targetInput).attr('value');
    const otherParent = $(targetInput).parent().parent().siblings()[0];
    const otherInput = $(otherParent).find('.request-qty')[0];

    const disableElem = (elem) => {
      $(elem).addClass('disabled')
    }

    const removeDisableElem = (elem) => {
      $(elem).removeClass('disabled')
    }

    // if the changed input is the fulfilled one
    if (targetInputId.includes('qtyFulfilled')) {
      // if purchased amount is more than requested
      // or equal to its original amount
      if (parseInt(targetValue) >= parseInt($(otherInput).val())) {
        // disable the increase button
        disableElem(targetPlus)
      } else {
        // remove disabled from the increase button
        removeDisableElem(targetPlus)
      }

        // cant be less than original amount
      if (parseInt(origininalTargetAmount) >= parseInt(targetValue)) {
        disableElem(targetMinus)
      } else {
        removeDisableElem(targetMinus)
      }

    // otherwise its probably the requested one
    } else if (targetInputId.includes('qtyRequested')) {
        // cant be less than original amount
      if (parseInt($(otherInput).val()) >= parseInt(targetValue)) {
        disableElem(targetMinus)
      } else {
        removeDisableElem(targetMinus)
      }
    }
  }

  const checkToggleChanges = (e) => {
    const targetSpan = e.target;
    const targetInput = $(targetSpan).siblings('.request-qty')[0];
    const targetValue = $(targetInput).val();
    const targetInputId = $(targetInput).attr('name');
    const targetMinus = $(targetInput).siblings('.stepperQtyMinus')[0];
    const targetPlus = $(targetInput).siblings('.stepperQtyPlus')[0];
    const origininalTargetAmount = $(targetInput).attr('value');
    const otherParent = $(targetInput).parent().parent().siblings()[0];
    const otherInput = $(otherParent).find('.request-qty')[0];

    const disableElem = (elem) => {
      $(elem).addClass('disabled')
    }

    const removeDisableElem = (elem) => {
      $(elem).removeClass('disabled')
    }

    // if the changed input is the fulfilled one
    if (targetInputId.includes('qtyFulfilled')) {
      // if purchased amount is more than requested
      // or equal to its original amount
      if (parseInt(targetValue) >= parseInt($(otherInput).val())) {
        // disable the increase button
        disableElem(targetPlus)
      } else {
        // remove disabled from the increase button
        removeDisableElem(targetPlus)
      }

        // cant be less than original amount
      if (parseInt(origininalTargetAmount) >= parseInt(targetValue)) {
        disableElem(targetMinus)
      } else {
        removeDisableElem(targetMinus)
      }

    // otherwise its probably the requested one
    } else if (targetInputId.includes('qtyRequested')) {
        // cant be less than original amount
      if (parseInt($(otherInput).val()) >= parseInt(targetValue)) {
        disableElem(targetMinus)
      } else {
        removeDisableElem(targetMinus)
      }
    }
  }


  if (registryItems) {
    for (let i = 0; i < registryItems.length; i++) {
      const parent = registryItems[i];
      const input = $(parent).find('.request-qty')[0]

      // event listener for 'input' changes
      if (input) {
        input.addEventListener('input', checkInputChanges)
      }
      // event listener for 'toggle' changes
      const spans = $(parent).find('.update');
      for (let s = 0; s < spans.length; s++) {
        const span = spans[s];
        $(span).on('click tap', checkToggleChanges)
      }

    }
  }
   
  const getDisabledMinus = () => {
    const items = document.querySelectorAll('.count-action');
  
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const requestedElm = item.querySelector('[id^="qtyRequested_"]');
      const fulfilledElm = item.querySelector('[id^="qtyFulfilled_"]');
      if (parseInt($(requestedElm).val()) <= parseInt($(fulfilledElm).val())) {
        const minusBtn = $(requestedElm).prev()[0];
        $(minusBtn).addClass('disabled');
      }
      if (parseInt($(fulfilledElm).val()) >= parseInt($(requestedElm).val())) {
        const plusBtn = $(fulfilledElm).next()[0];
        $(plusBtn).addClass('disabled');
      }

    }
  }
  getDisabledMinus();


}